import React, { useEffect, useState } from "react";
import modelAkmil from "../../assets/jumbotron/model_AKMIL.webp"
// import "./JumbotronAkmil.css"

const JumbotronAkmil = () => {
  const [provinsi, setProvinsi] = useState(0);
  const [soalLatihan, setSoalLatihan] = useState(0);
  const [kepuasan, setKepuasan] = useState(0);

  useEffect(() => {
    const provinsiInterval = setInterval(() => {
      setProvinsi((prev) => {
        if (prev < 38) {
          return prev + 1;
        }
        clearInterval(provinsiInterval);
        return prev;
      });
    }, 50);

    const soalLatihanInterval = setInterval(() => {
      setSoalLatihan((prev) => {
        if (prev < 5000) {
          return prev + 4;
        }
        clearInterval(soalLatihanInterval);
        return prev;
      });
    }, 1);

    const kepuasanInterval = setInterval(() => {
      setKepuasan((prev) => {
        if (prev < 98) {
          return prev + 1;
        }
        clearInterval(kepuasanInterval);
        return prev;
      });
    }, 30);

    return () => {
      clearInterval(provinsiInterval);
      clearInterval(soalLatihanInterval);
      clearInterval(kepuasanInterval);
    };
  }, []);
  return (
    <React.Fragment>
      <div className="container-jumbotron-kedinasan">
        <div className="text-jumbotron-kedinasan">
          <h1 className="title-jumbotron-kedinasan">
            BIMBEL SPESIALIS <br /> LOLOS AKADEMI TNI
          </h1>
          <p className="desk-jumbotron-kedinasan">
            Taruna Persada-Edumatrix Indonesia adalah Bimbel spesialis persiapan
            masuk Akademi TNI (AKMIL, AAL, AAU) yang berkomitmen membimbing siswa
            untuk bisa berhasil mewujudkan cita-cita sebagai abdi negara dan
            pastinya akan menjadi kebanggaan bagi pribadi dan keluarga.
          </p>

          <div className="text-jumbotron-kedinasan">
            <div className="container-counter-kedinasan">
              <div className="box-part-container-kedinasan">
                <h4 className="number-counter-kedinasan">{provinsi}</h4>
                <span className="text-counter">Provinsi</span>
              </div>
              <div className="box-part-container-kedinasan">
                <h4 className="number-counter-kedinasan">
                  {soalLatihan.toLocaleString()}+
                </h4>
                <span className="text-counter-kedinasan">Soal Latihan</span>
              </div>
              <div className="box-part-container-kedinasan">
                <h4 className="number-counter-kedinasan">{kepuasan}%</h4>
                <span className="text-counter-kedinasan">Kepuasan</span>
              </div>
            </div>
          </div>
        </div>
        <img
          src={modelAkmil}
          alt="Les Privat Masuk TNI Polri"
          className="img-model-jumbotron-akpol"
        />
      </div>
    </React.Fragment>
  );
};

export default JumbotronAkmil;
